import KitImage from '@omni/kit/components/KitImage';
import Colors from '@omni/kit/theming/Colors';
import Depth from '@omni/kit/theming/Depth';
import React, { ReactElement, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { PlayerAudioArtworkData } from './PlayerAudioArtwork.types';

const debug = require('debug')('tca:KitPlayer:components:PlayerAudioArtwork');

export default function PlayerAudioArtwork({
  url,
  color = Colors.N800,
  playerContainerDimensions,
}: PlayerAudioArtworkData): ReactElement | null {
  const blurImageUrl = useMemo(() => {
    if (!url) return;

    try {
      const imageUrl = new URL(url);

      imageUrl.searchParams.set('f', 'blur');

      return imageUrl;
    } catch (e) {
      debug('Invalid audio artwork url', url);
    }
  }, [url]);

  const { width, height } = playerContainerDimensions;
  const isPortrait = height >= width;

  return (
    <View
      pointerEvents='none'
      style={[StyleSheet.absoluteFill, { backgroundColor: color }]}
    >
      {url ? (
        <View style={styles.container}>
          <View style={styles.backgroundImage}>
            <KitImage
              source={{ uri: blurImageUrl?.toString() }}
              style={{
                width: '100%',
                height: '100%',
              }}
              resizeMode='cover'
            />
          </View>
          <View
            style={[styles.backgroundOverlay, { backgroundColor: color }]}
          />
          <View
            style={[
              styles.centeredImage,
              Depth.xl,
              isPortrait
                ? {
                    width: '100%',
                    height: width,
                  }
                : styles.landscapeStyle,
              { backgroundColor: color },
            ]}
          >
            <KitImage
              source={{ uri: url }}
              style={{ height: '100%', width: '100%' }}
              resizeMode='cover'
            />
          </View>
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backgroundImage: {
    ...StyleSheet.absoluteFillObject,
  },
  backgroundOverlay: {
    ...StyleSheet.absoluteFillObject,
    opacity: 0.8,
  },
  centeredImage: {
    overflow: 'hidden',
  },
  landscapeStyle: {
    aspectRatio: 1,
    height: '100%',
  },
});
